module.exports = __webpack_public_path__ + "static/img/3.c199c4a6.png";